/* @flow */
import ReactionEmojis from 'collections/ReactionEmojis';

export type State = {
  availableReactions: ReactionEmojis,
}

export const initialState: State = {
  availableReactions: new ReactionEmojis(),
};

export default function reducer(state: State = initialState, action: Object): State {
  switch (action.type) {
    case 'availableReactions/LOAD_REACTIONS_SUCCESS':
      return {
        ...state,
        availableReactions: action.availableReactions,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/availableReactions.js